'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.date = exports.money = exports.removeNonDigit = undefined;
var _formatters = require('./formatters');
var removeNonDigit = exports.removeNonDigit = function removeNonDigit(value) {
  return value.replace(/\D/g, '');
};
var money = exports.money = function money(value) {
  if (value === "") {
    return value;
  }
  var amount = value.replace(/\./g, '').replace(',', '.');
  return parseFloat(amount);
};
var date = exports.date = function date(value) {
  var tempVal = value.replace(/\_/g, '');
  if (tempVal.length === 10) {
    return (0, _formatters.formatDateToUS)(value);
  }
  return value;
};